import type { PlanTier } from './billing';

export interface UpgradeCTA {
  heading: string;
  description: string;
  primaryLabel: string;
  primaryRoute: string;
  secondaryLabel?: string;
  secondaryRoute?: string;
}

export function getUpgradeCTA(
  planTier: PlanTier | null,
  planSubTier: string | null,
  schoolPlan: 'school' | 'individual' | null = null,
): UpgradeCTA | null {
  if (!planTier || planTier === 'free') {
    return {
      heading: 'Upgrade your plan',
      description: 'Get more assessments, pupils, and classes with a paid plan.',
      primaryLabel: 'Upgrade to Individual',
      primaryRoute: '/individual-billing',
      secondaryLabel: 'View School Plans',
      secondaryRoute: '/school-billing',
    };
  }

  if (planTier === 'individual') {
    return {
      heading: 'Need more assessments?',
      description: 'School plans include higher monthly limits, team collaboration, and school-wide reporting.',
      primaryLabel: 'View School Plans',
      primaryRoute: '/school-billing',
    };
  }

  if (planTier === 'school') {
    // Skipped plan selection during setup — still on the open-ended trial (schools.plan_tier
    // defaults to 'school' with no sub-tier). Individual teachers land here too, so route by account type.
    if (!planSubTier && schoolPlan === 'individual') {
      return {
        heading: 'Choose your plan',
        description: 'Continue free, or upgrade to Individual for more assessments, pupils and classes.',
        primaryLabel: 'Choose a Plan',
        primaryRoute: '/individual-billing',
      };
    }
    if (!planSubTier) {
      return {
        heading: 'Choose your school plan',
        description: 'Pick the plan that fits your school. Card and invoice payment are both available.',
        primaryLabel: 'Choose a School Plan',
        primaryRoute: '/school-billing',
      };
    }
    if (planSubTier === 'starter') {
      return {
        heading: 'Need more assessments?',
        description: 'Standard includes 500 assessments/month. Plus includes 1,000.',
        primaryLabel: 'View Upgrade Options',
        primaryRoute: '/school-billing',
      };
    }
    if (planSubTier === 'standard') {
      return {
        heading: 'Upgrade to School Plus',
        description: 'School Plus includes 1,000 assessments per month.',
        primaryLabel: 'Upgrade to Plus',
        primaryRoute: '/school-billing',
      };
    }
    if (planSubTier === 'plus') {
      return {
        heading: 'Need even more?',
        description: 'Contact us to discuss MAT or custom pricing for multi-academy trusts.',
        primaryLabel: 'Contact Us',
        primaryRoute: '/contact',
      };
    }
  }

  return null;
}
